module.exports = __webpack_public_path__ + "static/media/icons_Bilan Cancer du Sein.97802080.svg";